import { render, staticRenderFns } from "./ParticularRegistro.vue?vue&type=template&id=8494f370&"
import script from "./ParticularRegistro.vue?vue&type=script&lang=js&"
export * from "./ParticularRegistro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports